import React, { FunctionComponent } from 'react';

import { PostalAddressStep as CommonPostalAddress } from 'scenes/common/components/Steps';
import {
  getPostalAddressOption,
  getMainAddress,
} from 'scenes/landlord/selectors';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import { PostalAddressOption } from 'scenes/common/flows/policyDetails/types';

const HELP_TEXT =
  'As this is a rental property, please provide an address you receive mail to.';

const BILLING_ADDRESS_OPTIONS = [
  {
    label: PostalAddressOption.StreetAddress,
    value: PostalAddressOption.StreetAddress,
  },
  {
    label: PostalAddressOption.LockedBagGpoAddress,
    value: PostalAddressOption.LockedBagGpoAddress,
  },
];

const PostalAddressStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <CommonPostalAddress
    onNext={onNext}
    helpText={HELP_TEXT}
    mainAddress={getMainAddress(funnelState)}
    postalAddressOption={getPostalAddressOption(funnelState)}
    options={BILLING_ADDRESS_OPTIONS}
  />
);

export default PostalAddressStep;
